export default "__VITE_ASSET__K14rY6Nd__"